<app-dialog-header headerText="Modify Organisation" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="max-width: 500px;">
		<mat-form-field *ngIf="dialogForm.get('Uid')?.value">
			<mat-label>ID:</mat-label>
			<input matInput autocomplete="off" formControlName="Uid" readonly>
			<mat-error *ngIf="dialogForm.get('Uid')!.hasError('required')">
				<span>UID is required</span>
			</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Name:</mat-label>
			<input matInput autocomplete="off" formControlName="Name" required>
			<mat-error *ngIf="dialogForm.get('Name')!.hasError('required')">
				<span>Name is required</span>
			</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Description:</mat-label>
			<input matInput autocomplete="off" formControlName="Description">
			<mat-error *ngIf="dialogForm.get('Description')!.hasError('required')">
				<span>Description is required</span>
			</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Function Location:</mat-label>
			<input matInput autocomplete="off" formControlName="FunctionalLocation">
			<mat-error *ngIf="dialogForm.get('FunctionalLocation')!.hasError('required')">
				<span>Functional Location is required</span>
			</mat-error>
		</mat-form-field>
		<app-image-container *ngIf="!creating"
							 [imgURL]="imageSrc"
							 [enablePicture]="enablePicture"
							 [enableCamera]="enableCamera"
							 [enableDelete]="enableDelete"
							 (onDelete)="deleteImg()" 
							 (onNewImage)="onNewImage($event)"></app-image-container>
		<div class="md-form mb-1 alignRow"
			style="display: grid; grid-template-columns: 1fr 1fr; gap: 0px 4px; padding: 0.5em; background-color: whitesmoke; border-bottom: 1px solid gray;">
			<div>
				<span>Reminder Interval (hours)</span>
				<ejs-numerictextbox [step]="1" formControlName="ReminderInterval" cssClass="e-custom" [min]="1"
					placeholder="Reminder Interval">
				</ejs-numerictextbox>
			</div>
			<!-- <span class="toolbar-spacer"></span> -->
			<div>
				<mat-label>Reminders Enabled:</mat-label>
				<mat-slide-toggle formControlName="RemindersEnabled" color="primary"></mat-slide-toggle>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button (click)="onSaveClick()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>
